module.exports = __webpack_public_path__ + "static/img/wd1.5cebfe1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workimg/wd1.png
// module id = XI62
// module chunks = 10